// Central config for calls to the Aldealista API.
// The public web endpoints require the shared API key, injected at build time
// via REACT_APP_API_KEY and sent as the `x-api-key` header. Note: this key
// ships inside the browser bundle, so it is not a true secret — the real abuse
// protection is the server-side CORS allowlist + rate limiting. It mainly stops
// trivially scripted, non-browser abuse.
export const API_BASE = "https://services.aldealista.com";
export const WEB_API_KEY = process.env.REACT_APP_API_KEY || "";
export const webApiHeaders = { "x-api-key": WEB_API_KEY };
